module.exports = __webpack_public_path__ + "enterprise-ux-research.1e9o8iK9.svg";